<template>
  <Drawer
    :id="drawerId"
    title="Add Card"
    padded
    @close="show = false"
  >
    <PaymentEntryForm
      mode="setup"
      :showCards="false"
      :returnUrl="returnUrl"
      @success="onSuccess"
    />
  </Drawer>
</template>

<script>
import { DRAWERS, ROUTES } from '../../utils/constants';
import Drawer from '../../components/layout/Drawer';
import PaymentEntryForm from './PaymentEntryForm';

export default {
  name: 'AddCardDrawer',

  components: {
    Drawer,
    PaymentEntryForm
  },

  data () {
    return {
      drawerId: DRAWERS.ADD_CARD_DRAWER
    };
  },

  computed: {
    returnUrl () {
      return this.$store.state.config.dashboardUrl + ROUTES.CARDS.PATH;
    }
  },

  methods: {
    async onSuccess () {
      await this.$store.dispatch('cards/getAll');
      this.$store.commit('drawers/CLOSE_DRAWER', DRAWERS.ADD_CARD_DRAWER);
    }
  }
};
</script>

<style>
</style>
